import React from 'react';
import { Helmet } from 'react-helmet-async';
import { pageSEO } from '../utils/seo';

const TermsPage: React.FC = () => {
  const seo = pageSEO.terms;

  return (
    <>
      <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://goodtimerent.kr/terms" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={seo.title} />
        <meta name="twitter:description" content={seo.description} />
      </Helmet>

      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-3xl font-bold mb-8 text-center">자동차대여 표준약관</h1>

      <div className="prose prose-slate max-w-none">
        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">제 1 장 총칙</h2>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제1조(목적)</h3>
            <p>
              이 약관은 대여용자동차 임대인(이하 "회사"라 합니다)과 임차인(이하 "고객"이라 합니다) 사이의 대여용자동차 임대차계약(이하 "대여계약"이라 합니다)상의 권리․의무에 관한 사항을 규정함을 목적으로 합니다.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">제 2 장 대여계약</h2>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제2조(예약의 체결)</h3>
            <p className="mb-3">
              ①대여용자동차(이하 "렌터카"라 합니다)를 임차하려는 자는 미리 차종, 대여요금, 지연손해금, 임차예정일시, 임차장소, 임차기간, 반환장소, 운전자, 기타 임차조건 등을 확인하여 예약을 할 수 있으며, 회사는 대여예정요금의 10%범위 내에서 예약금을 청구할 수 있습니다.
            </p>
            <p>
              ②고객이 예약내용을 변경하고자 할 때에는 사전에 회사와 합의하여야 합니다.
            </p>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제3조(예약의 취소)</h3>
            <p className="mb-2">
              ①임차예정 시간을 1시간 이상 경과하여도 대여계약이 체결되지 아니한 경우에는 예약은 취소된 것으로 합니다. 이 경우 예약금은 반환하지 아니합니다.
            </p>
            <p className="mb-2">
              ②고객이 자신의 사정으로 임차예정일시로부터 24시간 이전에 예약을 취소하는 경우에는 예약금 전액을 반환합니다.
            </p>
            <p className="mb-2">
              ③고객이 자신의 사정으로 임차예정일시 직전 24시간 내에 예약을 취소하는 경우에는 예약금을 반환하지 아니합니다.
            </p>
            <p className="mb-2">
              ④회사는 예약금을 수령한 후 회사의 사정으로 예약을 취소하거나 대여계약을 체결하지 못할 경우에는 고객에게 사유를 설명하고 예약금의 배액을 지급합니다.
            </p>
            <p>
              ⑤제2조에 따른 예약을 한 후 천재지변 등 불가항력적인 사유로 인하여 계약을 체결할 수 없게 된 경우에는 회사는 예약금을 고객에게 반환합니다.
            </p>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제4조(대여계약의 체결)</h3>
            <p className="mb-3">
              ①대여계약의 체결은 임대차계약서에 의하며, 임대차계약서에는 제2조 제1항에서 열거한 사항을 명시하여야 합니다.
            </p>
            <p className="mb-2">
              ②회사는 고객이 다음 각 호의 어느 하나에 해당할 경우 대여계약의 체결을 거절할 수 있으며, 이 경우 지급받은 예약금을 반환합니다.
            </p>
            <ul className="list-decimal ml-6 space-y-2">
              <li>고객(고객 아닌 자가 임대차계약서상의 운전자인 경우에는 운전자를 말한다, 이하 이 조에서 같다)이 렌터카운전에 필요한 운전면허증을 소지하지 아니하거나 회사의 운전자격 확인에 고객이 협조하지 아니한 경우(다만, 회사는 사고발생의 빈도 및 보험적용요율 등을 감안하여 고객의 연령 및 운전경력 등을 특약으로 정할 수 있습니다)</li>
              <li>신원확인이 불가능하거나 회사의 질문 및 자료요구에 불응할 때</li>
              <li>고객이 음주상태에 있거나, 마약, 각성제, 신나 등 약물에 중독되었다고 판단될 때</li>
              <li>예약 당시 결정한 운전자와 렌터카 인수시의 운전자가 다를 때</li>
              <li>과거 렌터카 대여와 관련하여 고의로 교통사고를 발생시킨 사실 또는 대여요금, 면책금, 수리비 등의 체납 사실이 객관적으로 인정될 때</li>
              <li>과거 렌터카 대여와 관련하여 제15조 각호에 해당하는 행위가 있었을 때</li>
              <li>위 각호에 준하는 사항으로서 대여계약의 체결을 거절할 만한 객관적인 사유가 있을 때</li>
            </ul>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제5조(렌터카의 대체)</h3>
            <p className="mb-2">
              ①회사는 고객이 예약한 차종의 렌터카를 대여할 수 없을 경우에는 유사한 다른 차종의 렌터카로 대체할 수 있습니다.
            </p>
            <p className="mb-2">
              ②제1항에 의한 대체 렌터카의 대여요금이 예약차종의 대여요금보다 비싼 경우에는 예약차종의 대여요금을, 예약차종의 대여요금보다 싼 경우에는 대체 렌터카의 대여요금을 각 적용합니다.
            </p>
            <p>
              ③고객은 제1항에 의한 대체 렌터카의 임차를 거절할 수 있으며, 이 경우 회사는 고객에게 예약금 전액을 반환합니다.
            </p>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제6조(요금의 수령방법 등)</h3>
            <p className="mb-2">
              ①고객은 원칙적으로 약정한 대여요금을 선납하여야 합니다. 다만, 회사와 고객은 대여요금을 분납하거나 사용 후에 지급하기로 별도의 약정을 할 수 있습니다.
            </p>
            <p className="mb-2">
              ②고객의 요구로 인하여 대여요금 외의 추가비용이 발생한 경우에는 고객은 그 추가비용을 부담하여야 합니다.
            </p>
            <p>
              ③고객은 임차기간을 초과하여 렌터카를 사용한 경우에는 렌터카 반환시추가로 대여요금을 지급하여야 합니다.
            </p>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제7조(회사의 대여계약 해지)</h3>
            <p className="mb-2">
              ①회사는 다음 각 호의 어느 하나에 해당하는 경우에는 계약을 해지할 수 있습니다.
            </p>
            <ul className="list-decimal ml-6 space-y-2 mb-3">
              <li>고객이 계약의 중요한 사항을 위반하여 계약을 유지하기 어려운 객관적인 사정이 존재할 때</li>
              <li>계약 당시 고객의 개인정보가 허위로 판명된 때</li>
              <li>대여요금을 분할납부하기로 한 경우로서 대여기간 중 차임연체액이 2기의 대여요금에 달한 때</li>
              <li>고객(고객 아닌 자가 임대차계약서상의 운전자인 경우에는 운전자를 말한다. 이하 이 항에서 같다)의 운전면허가 취소 또는 정지된 때</li>
              <li>고객이 교통사고를 야기한 때</li>
              <li>렌터카 대여 후 고객이 음주운전을 한 때</li>
              <li>렌터카 대여 후 고객이 마약, 각성제, 신나 등 약물에 취한 채 운전한 때</li>
              <li>임대차계약서상의 운전자 이외의 자(고객이 임차 후 임대차계약서상의 운전자가 주취, 신체부상 등의 사유로 직접 운전이 불가능하여 「소득세법」 제173조제1항에 따른 대리운전 용역제공자에게 운전을 대리하게 한 경우 그 대리운전 용역제공자는 제외한다)가 운전을 한 때</li>
              <li>제15조의 금지행위를 한 때</li>
            </ul>
            <p>
              ②제1항에 따라 계약이 해지된 경우 회사는 잔여기간 대여요금의 10%를 공제한 후 대여요금(고객이 실제 납부한 요금을 말한다)을 고객에게 지급하여야 하고, 고객은 렌터카를 반환하여야 합니다.
            </p>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제8조(고객의 대여계약 해지)</h3>
            <p className="mb-2">
              ①고객은 렌터카 인도이전의 하자로 인하여 렌터카를 사용할 수 없는 때에는 제20조 제3항에 의한 조치를 받거나 대여계약을 해지할 수 있습니다.
            </p>
            <p className="mb-2">
              ②제1항에 따라 대여계약이 해지된 경우에는 회사는 수령한 대여요금 전액을 고객에게 반환합니다.
            </p>
            <p className="mb-2">
              ③고객은 임차기간 중이라도 회사와 합의하여 대여계약을 해지할 수 있습니다.
            </p>
            <p className="mb-2">
              ④고객의 사정에 의하여 대여계약을 해지하는 경우에는 고객은 잔여기간 대여요금의 10% 상당액을 회사에 지급하여야 합니다. 다만, 6개월 이상 장기계약의 경우 회사와 고객은 회사의 손실을 고려하여 중도해지시의 수수료를 별도로 약정할 수 있습니다.
            </p>
            <p>
              ⑤고객의 귀책사유로 렌터카의 사고 또는 고장이 발생한 경우 고객은 회사에 그 손해를 배상하고 계약을 해지할 수 있습니다.
            </p>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제9조(불가항력 사유로 인한 대여계약 해지)</h3>
            <p className="mb-2">
              ①임차기간 중 천재지변, 전쟁, 내란, 사변, 폭동, 소요 등 기타 불가항력 사유로 인하여 고객이 렌터카를 사용할 수 없는 경우에는 대여계약은 종료되며, 고객은 이와 같은 사실을 회사에 통보하여야 합니다.
            </p>
            <p className="mb-2">
              ②제1항에 의하여 대여계약이 종료된 경우 회사는 수령한 대여요금에서 대여계약이 종료된 때까지의 대여요금을 공제한 나머지 금액을 고객에게 반환합니다.
            </p>
            <p className="mb-2">
              ③고객이 제1항의 사유로 인하여 렌터카를 반환할 수 없는 때에는 회사는 고객에게 이로 인하여 발생한 손해의 배상을 청구할 수 없습니다. 다만, 고객은 제1항의 사유가 발생한 경우 즉시 회사에 연락하고, 회사의 요청에 협조하여야 합니다.
            </p>
            <p>
              ④제1항의 사유로 인하여 회사가 렌터카를 대여할 수 없거나 대체렌터카를 제공할 수 없을 때에는 고객은 회사에 이로 인하여 발생한 손해의 배상을 청구할 수 없습니다.
            </p>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제10조(임차조건의 변경)</h3>
            <p className="mb-2">
              ①고객이 대여계약의 체결 후 임차조건을 변경하고자 하는 경우에는 미리 회사의 승낙을 받아야 합니다.
            </p>
            <p className="mb-2">
              ②고객이 임차기간을 연장하고자 하는 경우에는 변경 후의 임차기간에 해당하는 대여요금을 지불하여야 합니다.
            </p>
            <p>
              ③회사는 변경된 임차조건에 따라 업무를 수행하기 어려운 경우에는 변경을 승낙하지 않을 수 있습니다.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">제 3 장 보험 및 점검 등</h2>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제11조(보험가입 등)</h3>
            <p className="mb-2">
              ①회사는 고객에게 자동차손해배상보장법에 따라 책임보험과 자동차종합보험(대인배상, 대물배상, 자기신체사고)에 가입된 렌터카를 대여합니다. 이 경우, 고객은 자동차보험약관상 승낙피보험자가 됩니다.
            </p>
            <p className="mb-2">
              ②고객은 차량사고 발생시 손해를 줄이기 위해 자기차량손해에 대한 보험 또는 회사가 고객을 보호하기 위해 운영하는 차량손해면책제도 중 하나를 선택하여 가입할 수 있습니다.
            </p>
            <p>
              ③회사는 계약체결시 고객에게 보험가입 및 보장금액에 관한 사항을 설명하여야 합니다.
            </p>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제12조(점검표 작성 등)</h3>
            <p className="mb-2">
              ①회사는 고객과 함께 별표의 점검표에 의해 일상점검과 차체외관, 기본공구의 적재, 연료(전기와 수소를 포함하며, 이하 같습니다)량, 타이어, 와이퍼, 라이트, 사이드미러, 윈도우, 안전벨트 등을 점검한 후 렌터카를 인도합니다.
            </p>
            <p>
              ②회사는 제1항에 따른 렌터카 인도 전 점검 또는 회사가 일상적으로 실시하는 점검시 렌터카의 정비불량 등을 발견한 경우에는 수리 또는 부품교환 등의 조치를 취하고 그 내용을 기록ㆍ유지하여야 하며, 고객이 요청할 경우 그 조치의 시기와 내용을 고객이 열람할 수 있도록 합니다.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">제 4 장 책임</h2>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제13조(고객의 점검의무)</h3>
            <p className="mb-2">
              ①고객은 임차기간 중 렌터카를 사용하기 전에 타이어나 차체의 외관상태 및 시동 후 엔진상태 등을 점검하여야 합니다.
            </p>
            <p className="mb-2">
              ②고객은 제1항의 점검결과 이상이 발견된 경우에는 즉시 회사에 이를 통보하여야 합니다.
            </p>
            <p>
              ③고객은 회사의 ｢자동차관리법｣에 따른 정기검사, 자동차종합검사 또는 자동차 결함 시정조치(리콜) 이행을 위한 협조요청에 적극 따릅니다.
            </p>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제14조(고객의 관리책임)</h3>
            <p>
              고객은 렌터카를 인도받은 시점부터 회사에 반환하는 시점까지 선량한 관리자의 주의의무를 다하여 렌터카를 사용하고 보관하여야 합니다.
            </p>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제15조(금지행위)</h3>
            <p className="mb-2">
              고객은 임차기간 중에 다음 각호의 어느 하나에 해당하는 행위를 하여서는 아니됩니다.
            </p>
            <ul className="list-decimal ml-6 space-y-2">
              <li>렌터카를 자동차운송사업 또는 이와 유사한 목적으로 사용하는 행위</li>
              <li>렌터카의 매각, 전대 또는 담보제공 등 회사의 소유권을 침해하는 일체의 행위</li>
              <li>렌터카의 차량번호판을 위조 또는 변조하거나 렌터카를 개조하는 등 그 원상을 변경하는 행위</li>
              <li>회사의 허락을 받지 아니하고 렌터카를 운전연습 및 각종 시험ㆍ경기에 사용하거나 다른 차를 견인하거나 견인에 준하는 행위</li>
              <li>법령 또는 공서양속에 위반하여 사용하는 행위</li>
              <li>임대차계약서상의 운전자 이외의 자(고객이 임차 후 임대차계약서상의 운전자가 주취, 신체부상 등의 사유로 직접 운전이 불가능하여 「소득세법」 제173조제1항에 따른 대리운전 용역제공자에게 운전을 대리하게 한 경우 그 대리운전 용역제공자는 제외한다) 또는 무면허자에게 운전을 시키는 행위</li>
              <li>음주운전을 하거나 마약, 각성제, 신나 등 약물에 취한 상태로 운전하는 행위</li>
              <li>석유 및 석유대체연료 사업법 제2조 제10호의 규정에 의한 유사석유제품을 렌터카의 연료로 사용하는 행위</li>
              <li>위 각 호에 준하는 행위로 객관적으로 보아 그로 인하여 렌터카를 손상시킬 우려가 있는 행위</li>
            </ul>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제16조(배상책임)</h3>
            <p className="mb-2">
              ①고객은 임차기간 중 제15조에 해당하는 행위 기타 고객의 책임있는 사유로 인하여 회사 또는 제3자에게 손해를 끼쳤을 경우 그 손해를 배상할 책임을 집니다.
            </p>
            <p>
              ②고객이 임차기간 중 주정차 위반과 교통법규 위반 등으로 인하여 부과받은 과태료와 범칙금 및 주차료 등은 렌터카 반환 후에도 부담하여야 합니다.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">제 5 장 자동차 사고의 조치 등</h2>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제17조(사고처리)</h3>
            <p className="mb-2">
              ①고객은 렌터카 임차 중 사고가 발생한 때에는 부상자 후송 및 경찰서 신고 등 도로교통법상의 조치를 취함과 동시에 다음 각 호에서 정하는 바에 따라 처리하여야 합니다.
            </p>
            <ul className="list-decimal ml-6 space-y-2 mb-3">
              <li>사고상황 등을 회사에 즉시 통보</li>
              <li>사고와 관련하여 보험회사가 요청하는 서류 또는 증거의 제출</li>
              <li>사고와 관련하여 제3자와 합의 또는 협의를 할 경우 사전에 회사와 협의</li>
              <li>렌터카의 수리는 특별한 사유가 있는 경우를 제외하고는 회사와 협의를 거쳐 확정한 공장 또는 자동차관리법령에서 규정한 자동차종합정비업체 등에 수리 의뢰</li>
            </ul>
            <p className="mb-2">
              ②회사는 제1항 제4호에 따라 렌터카를 수리하는 경우 사전에 예상비용을 고객에게 통지하고, 수리 후에는 소요된 비용을 고객에게 청구합니다. 이 경우 회사는 고객이 요청하면 수리내역 증빙자료(수리 전 정비견적서, 수리 후 정비명세서)를 제공합니다.
            </p>
            <p className="mb-2">
              ③회사는 고객과 협의하여 고객이 차량을 수리한 경우 차량 정비내역제출을 요구할 수 있습니다.
            </p>
            <p className="mb-2">
              ④고객이 제1항 각 호의 어느 하나를 위반하거나 회사와 협의되지 아니한 곳으로 렌터카를 이동, 견인, 수리 등을 행하여 렌터카 운행에 지장이 초래되어 재수리 등으로 발생하는 추가비용은 고객이 부담하여야 합니다.
            </p>
            <p>
              ⑤회사와 고객은 사고해결을 위해 노력하여야 하며, 협조를 태만히 하여 상대방에게 손해를 입힌 경우에는 귀책사유에 따라 그 손해를 배상할 책임을 집니다.
            </p>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제18조(보험처리 등)</h3>
            <p className="mb-2">
              ①고객은 사고발생시 회사가 체결한 자동차보험 및 제11조 제2항에 의한 자기차량손해보험 또는 차량손해면책제도의 보장범위 내에서 손해를 보상받을 수 있습니다. 다만, 고객 또는 임대차계약서상 운전자의 다음 각 호의 어느 하나에 해당하는 사유로 발생한 손해와 자동차보험약관에서 정한 면책사항에 해당하는 경우에는 일부 또는 전부를 보상받지 못합니다.
            </p>
            <ul className="list-decimal ml-6 space-y-2 mb-3">
              <li>고의로 인한 손해</li>
              <li>무면허운전 사고로 인한 손해</li>
              <li>영리를 목적으로 렌터카를 전대하거나 요금 또는 대가를 받고 렌터카를 사용하다가 생긴 사고로 인한 손해</li>
              <li>범죄를 목적으로 렌터카를 사용하다가 발생한 손해</li>
              <li>음주운전 사고로 인한 손해</li>
              <li>마약, 각성제, 신나 등 약물에 취한 상태에서 운전하다가 생긴 사고로 인한 손해</li>
              <li>렌터카를 경기용이나 연습용 또는 시험용으로 사용하다가 생긴 사고로 인한 손해</li>
              <li>임대차계약서상의 운전자 이외의 자(고객이 임차 후 임대차계약서상의 운전자가 주취, 신체부상 등의 사유로 직접 운전이 불가능하여 「소득세법」 제173조제1항에 따른 대리운전 용역제공자에게 운전을 대리하게 한 경우 그 대리운전 용역제공자는 제외한다)가 렌터카를 운전하다가 생긴 사고로 인한 손해</li>
            </ul>
            <p className="mb-2">
              ②고객은 제1항의 보상을 받음에 있어, 고객의 귀책사유로 인한 사고의 경우 보험사(자기차량손해보험에 가입한 경우) 또는 회사(차량손해면책제도에 가입한 경우)에 대여자동차의 손해에 대한 자기부담금을 별도로 지급하여야 합니다. 다만, 고객이 차량손해면책제도에 가입한 경우 고객이 납부하는 자기부담금(제19조에 따라 고객이 부담하는 휴차손해는 제외)은 렌터카에 대하여 실제 발생한 수리비를 한도로 합니다.
            </p>
            <p className="mb-2">
              ③고객이 제11조 제2항의 자기차량손해보험 또는 차량손해면책제도에 가입하지 않고 사고가 발생하여 차량이 파손된 경우 고객은 사고당시 차량기준가액 등을 기준으로 회사에 손해를 배상하여야 합니다.
            </p>
            <p className="mb-2">
              ④제11조 제2항의 자기차량손해보험 또는 차량손해면책제도에 의한 보장금액이 고객의 배상책임금액보다 부족한 때에는 그 부족액은 고객이 부담하여야 합니다.
            </p>
            <p>
              ⑤대여계약이 종료되었음에도 고객이 회사에 렌터카를 반환하지 않고 운행하다가 생긴 사고는 회사의 자동차보험 가입에도 불구하고 고객이 손해배상책임을 져야 하며, 그 사고로 인하여 회사에 손해가 발생한 경우에는 고객은 회사에 그 손해를 배상하여야 합니다.
            </p>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제19조(휴차손해 등 부담)</h3>
            <p className="mb-2">
              ①고객은 고객의 귀책사유에 의한 사고로 렌터카를 수리할 경우에는 그 수리기간의 영업손해를 배상하여야 하고, 렌터카가 수리 불가능할 정도로 파손되거나 도난된 경우에는 렌터카의 재구매 및 등록 등에 소요되는 기간의 영업손해를 부담하여야 합니다.
            </p>
            <p className="mb-2">
              ②회사는 제1항에 의하여 고객이 부담할 손해액을 정하는 경우 동종차량의 대여요금 등을 감안한 객관적인 산정자료를 제시하여야 합니다.
            </p>
            <p className="mb-3">
              ③회사가 제2항에 의한 객관적인 산정자료를 제시하지 않는 경우 고객은 수리기간 또는 재구매 및 등록에 소요되는 기간에 해당하는 대여요금의 50%를 부담하여야 합니다. 이때 대여요금은 수리기간 또는 재구매 및 등록에 소요되는 기간에 해당하는 일일대여요금(고객이 실제 납부한 요금을 말한다)을 기준으로 산정합니다.
            </p>
            <div className="bg-gray-50 p-4 rounded-lg text-sm">
              <p className="font-bold mb-2">예시)</p>
              <p className="mb-2">
                고객이 A 승용차를 임차하여 운행 중에 자신의 귀책사유로 인한 사고로 렌터카를 파손하여 동 차량의 수리에 10일이 소요된 경우 위 제19조 제3항에 따라 고객이 부담하여야하는 회사의 영업손해는 아래와 같습니다.
              </p>
              <p className="mb-2">
                회사의 영업손해(휴차손해) = [73,000원(7일 이상 대여시 일일대여요금) × 10일(수리기간) = 730,000원]의 50% = 365,000원
              </p>
              <p className="text-xs text-gray-600">
                ※ 회사의 A승용차 대여료(가정)<br />
                · 대여기간 1～2일 : 일일대여요금 91,000원<br />
                · 대여기간이 7일 이상 : 일일대여요금 73,000원
              </p>
            </div>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제20조(고객의 렌터카 이상 또는 고장 발견시 조치)</h3>
            <p className="mb-2">
              ①고객은 임차 중 렌터카의 이상 또는 고장을 발견한 때에는 회사에 연락하고 그 처리방향에 대하여 협의하여야 합니다.
            </p>
            <p className="mb-2">
              ②고객의 고의ㆍ과실로 렌터카의 이상이나 고장이 발생한 경우에는 렌터카의 인수 및 수리에 소요되는 비용을 고객이 부담하여야 합니다.
            </p>
            <p className="mb-2">
              ③렌터카 인도이전의 하자로 인하여 렌터카를 사용 불능하게 되거나 수리가 필요하게 되었을 때 고객은 회사로부터 대체 렌터카의 제공 또는 이에 준하는 조치를 받을 수 있습니다.
            </p>
            <p>
              ④회사는 제3항에서 정한 조치를 할 수 없는 경우에는 고객에게 대여요금을 반환하고, 렌터카 회수 등에 필요한 비용을 부담합니다.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">제 6 장 반환</h2>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제21조(렌터카의 반환시기 등)</h3>
            <p>
              고객은 약정한 대여기간 종료시점 또는 대여계약 중도해지시에 렌터카를 회사에 반환하여야 합니다.
            </p>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제22조(렌터카의 확인 등)</h3>
            <p className="mb-2">
              ①고객은 렌터카를 회사에 반환할 때 통상적 사용으로 인한 마모 등을 제외하고는 인수시 확인한 상태 그대로 반환하여야 합니다.
            </p>
            <p className="mb-2">
              ②회사는 렌터카 반환 시 고객의 입회하에 렌터카의 상태를 확인합니다.
            </p>
            <p className="mb-2">
              ③회사가 렌터카를 반환받을 때에는 고객 입회하에 렌터카 내의 고객 또는 동승자의 유류품의 잔류 여부를 확인합니다.
            </p>
            <p>
              ④회사와 고객은 렌터카 반환․회수시 잔여 연료량의 과‧부족분에 대한 연료대금을 서로 정산합니다. 이를 위해 회사는 고객이 렌터카를 반환할 때의 연료량이 임대시의 연료량보다 부족한 경우에는 당해 부족분에 대한 연료대금을 요청할 수 있고 고객은 반환시의 연료량이 임차시의 연료량을 초과하는 경우에는 당해 초과분에 대한 연료대금을 회사에게 요청할 수 있습니다. 다만, 연료 정산의 편의와 정확성을 위해 회사가 연료탱크에 연료를 100% 채워 인도하는 경우 고객은 연료탱크에 연료를 100% 채워 반환합니다.
            </p>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제23조(렌터카의 반환장소 등)</h3>
            <p className="mb-2">
              ①고객은 약정한 반환장소에서 렌터카를 반환하여야 합니다. 다만, 제10조 제1항에 의하여 반환장소가 변경된 경우에는 변경 후의 반환장소에서 반환하여야 합니다.
            </p>
            <p>
              ②고객의 사정에 의하여 반환장소가 변경되어 렌터카회수에 추가비용이 발생한 경우에는 고객은 그 비용을 부담하여야 합니다.
            </p>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제24조(렌터카 미반환에 대한 조치)</h3>
            <p className="mb-2">
              ①회사는 고객이 대여기간 종료시로부터 24시간을 경과하여도 반환장소에 렌터카를 반환하지 아니하거나 회사의 반환 청구에 응하지 않을 때에는 렌터카 회수 및 손해보전에 필요한 모든 법적 조치를 취할 수 있습니다.
            </p>
            <p className="mb-2">
              ②회사는 제1항에 해당되는 경우 렌터카의 소재를 확인하기 위하여 고객에게 전화를 하거나 주소지를 방문하여 함께 거주하는 가족 및 친족 등에게 청취조사를 할 수 있으며, 차량위치정보시스템의 작동 등 필요한 조치를 취할 수 있습니다. 다만, 회사는 렌터카 대여시 차량위치정보 확인이 가능한 자동차를 대여할 경우에는 그 사실을 고객에게 고지하고 확인을 받아야 합니다.
            </p>
            <p className="mb-2">
              ③회사는 제2항의 조치에도 불구하고 대여기간 종료시로부터 7일이 경과하였음에도 렌터카와 고객의 소재가 불명한 때에는 도난신고 등 필요한 조치를 취할 수 있습니다. 이 경우 회사는 제2항에 따른 조치를 취하였음에도 렌터카와 고객의 소재가 불명함을 입증하여야 합니다.
            </p>
            <p className="mb-2">
              ④고객은 제1항 내지 제3항에 해당하는 경우 회사에 입힌 손해를 배상할 책임을 지며, 렌터카 회수 및 고객ㆍ운전자의 소재확인 등에 소요된 비용을 부담하여야 합니다.
            </p>
            <p className="mb-2">
              ⑤회사는 다음 각 호의 어느 하나에 해당하는 고객의 계약위반으로 인한 동종 또는 유사한 피해를 방지하기 위하여 계약시 수집․이용목적, 수집항목, 보유 및 이용기간 등이 기재된 별도의 "개인정보 이용동의서" 및 개인정보를 제공받는 자, 목적, 항목, 보유 및 이용기간 등이 기재된 별도의 "제3자 제공동의서"에 동의를 받아 피해가 발생한 경우에 한하여 동종사업자 및 사업자단체에게 개인정보를 제공할 수 있습니다.
            </p>
            <ul className="list-decimal ml-6 space-y-2 mb-3">
              <li>고객이 회사의 렌터카 반환요구에도 불구하고 정당한 사유 없이 렌터카를 반환하지 않거나 연락이 되지 않는 상태에서 렌터카 반환일로부터 익일 영업시간 내에 반환하지 아니한 경우</li>
              <li>고객이 대여요금을 연체하여 회사가 상당기간 동안 2회 이상 납부를 최고하였음에도 계속 연체하고 있는 경우. 단, 고객에게 부득이한 사유가 있는 경우에는 제외합니다.</li>
              <li>렌터카를 불법 매매 또는 개조한 경우</li>
              <li>차량번호판 위조 또는 범죄에 사용하는 등 불법행위에 이용한 경우</li>
              <li>렌터카를 전대, 담보제공 또는 매각하는 등 회사의 소유권을 침해하는 일체의 행위를 한 경우</li>
              <li>교통사고 후 도주 또는 렌터카를 방치한 경우</li>
              <li>렌터카를 자동차운송사업 또는 이와 유사한 목적으로 사용한 경우</li>
              <li>임대차계약서상의 운전자 이외의 자(고객이 임차 후 임대차계약서상의 운전자가 주취, 신체부상 등의 사유로 직접 운전이 불가능하여 「소득세법」 제173조제1항에 따른 대리운전 용역제공자에게 운전을 대리하게 한 경우 그 대리운전 용역제공자는 제외한다) 및 무면허운전자가 운전하다 사고가 발생한 경우</li>
              <li>렌터카를 운전연습 및 각종 시험ㆍ경기에 사용한 경우</li>
              <li>다른 차를 견인 혹은 견인에 준하는 행위를 한 경우</li>
              <li>위 각 호에 준하는 행위로 회사에 중대한 손해를 발생시키는 경우</li>
            </ul>
            <p className="mb-2">
              ⑥회사는 고객이 임차기간 중 주정차 위반과 교통법규 위반으로 인하여 부과받은 과태료와 범칙금의 징수를 위하여 계약시 수집ㆍ이용목적, 수집항목, 보유 및 이용기간 등이 기재된 별도의 "개인정보 이용동의서" 및 개인정보를 제공받는 자, 목적, 항목, 보유 및 이용기간 등이 기재된 별도의 "제3자 제공동의서"에 동의를 받아 국가 또는 지방자치단체 등 해당 과태료와 범칙금의 부과 주체에게 개인정보를 제공할 수 있습니다.
            </p>
            <p className="mb-2">
              ⑦회사는 제5항 및 제6항에 따라 제공받은 고객의 정보를 고객으로부터 동의받은 목적과 다른 목적으로 이용할 수 없습니다.
            </p>
            <p>
              ⑧회사가 제1항 내지 제7항에 의한 업무를 처리하는 과정에서 고의 또는 과실로 고객에게 손해를 입힌 경우에는 배상책임을 부담합니다.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">제 7 장 보칙</h2>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제25조(지연손해금)</h3>
            <p>
              회사와 고객은 이 약관에 따른 금전채무의 이행을 지체한 경우 상사법정이율에 따른 지연손해금을 지급하여야 합니다.
            </p>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제26조(계약의 세칙)</h3>
            <p>
              회사는 이 약관이 정한 범위 내에서 고객의 이해가 용이하도록 세부사항을 규정하는 세칙을 정할 수 있습니다.
            </p>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제27조(신용조회)</h3>
            <p>
              회사는 고객의 동의를 받아 대여계약 체결 전 신용정보기관을 통하여 고객의 신용상태를 조회ㆍ확인할 수 있습니다.
            </p>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-bold mb-3">제28조(관할법원)</h3>
            <p>
              이 약관의 해석과 이에 근거한 대여계약에 관련된 법적 분쟁이 발생할 경우 소송은 민사소송법상의 관할법원에 제기합니다. 단, 회사와 고객이 관할법원에 대해 약정할 경우에는 그에 따릅니다.
            </p>
          </div>
        </section>
      </div>
      </div>
    </>
  );
};

export default TermsPage;
